import React from "react";

// react router
import { Link } from 'react-router-dom'

// styles
import {
	BreadcrumbsHeaderContainer,
} from "../../styles/AboutUsStyles";

function Breadcrumbs(props) {
	// props
	const { currentRoute } = props

	return (
		<BreadcrumbsHeaderContainer>
			<div className="container">
				{/* heading */}
				<h1 className="heading">{currentRoute?.routeName}</h1>
				{/* links */}
				<div
					className="ec-breadcrumbs"
					aria-label="Breadcrumbs"
					role="region"
				>
					<Link to="/" className="link text-uppercase text-decoration-none">Home</Link>&ensp;/&ensp;
					<a href={`/content/${currentRoute?.routeUrl}`} className="link text-uppercase text-decoration-none">
						{currentRoute?.routeName}
					</a>
				</div>
			</div>
		</BreadcrumbsHeaderContainer>
	);
}

export default Breadcrumbs;
